import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { PayinReqResLogs, StatusCheck } from "../services/payinReqResLogsService";

const initialState = {
  payinReqResLogsState: [],
  isLoading: true,
  statusData: {},
  statusLoading: true
};
export const getPayinReqResLogs = createAsyncThunk(
  "/payinRequestResponseLogs",
  async (payload) => {
    return await PayinReqResLogs(payload);
  }
);
export const getStatusCheck = createAsyncThunk(
  "/check/status",
  async (payload) => {
    return await StatusCheck(payload);
  }
);

const payinReqResLogsSlice = createSlice({
  name: "payinReqResLogsSlice",
  initialState,
  reducers: {
    clearPayinReqResLogs: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getPayinReqResLogs.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getPayinReqResLogs.fulfilled, (state, action) => {
      state.isLoading = false;
      state.payinReqResLogsState = action.payload;
    });
    builder.addCase(getPayinReqResLogs.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(getStatusCheck.pending, (state, action) => {
      state.statusLoading = true;
    });
    builder.addCase(getStatusCheck.fulfilled, (state, action) => {
      state.statusLoading = false;
      state.statusData = action.payload;
    });
    builder.addCase(getStatusCheck.rejected, (state, action) => {
      state.statusLoading = false;
    });
  },
});
export default payinReqResLogsSlice.reducer;
export const { clearPayinReqResLogs } = payinReqResLogsSlice.actions;

export const selectPayinReqResLogs = (state) => {
  return state.payinReqResLogs.payinReqResLogsState;
};

export const usePayinReqResLogs = () => {
  const payinReqResLogsState = useSelector(selectPayinReqResLogs);
  return useMemo(() => ({ payinReqResLogsState }), [payinReqResLogsState]);
};

export const selectStatusCheck = (state) => {
  return state.payinReqResLogs.statusData;
};

export const useStatusCheck = () => {
  const statusDataState = useSelector(selectStatusCheck);
  return useMemo(() => ({ statusDataState }), [statusDataState]);
};
